module.exports = "/packs/loading-8323fc84e1a1fdfab0c739ca9e58f70e.gif";